import { useAppDispatch } from 'app/store';
import { manageSubscriptionEffect } from 'app/store/Subscription/effects';
import {
  subscriptionManageButtonAction,
  subscriptionSubscribeButtonAction,
} from 'app/store/Mixpanel/slice';
import { openURL } from 'app/utils/utils';
import {
  useHandleSubscriptionPayload,
  useSubscription,
} from '../Subscription/hooks';
import { StorageComponent } from './StorageComponent';
import { useFetchStorage } from './hooks';
import { StorageLoader } from './StorageLoader';
import { getNextTier } from './utils';

export const Storage = () => {
  const dispatch = useAppDispatch();
  const storage = useFetchStorage();
  const {
    subscription,
    tierList,
    tierListLoading,
    subscriptionLoading,
    manageSubscriptionLink,
    subscriptionTiersDDL,
    subscriptionTiersDDLLoading,
  } = useSubscription();
  useHandleSubscriptionPayload();
  const nextTier = getNextTier(tierList, subscription);

  const onManageSubscriptionClick = async () => {
    dispatch(subscriptionManageButtonAction());
    const { response } = await dispatch(
      manageSubscriptionEffect({ link: manageSubscriptionLink })
    ).unwrap();

    if (response) {
      openURL(response._links.portal.href, {
        isExternal: true,
      });
    }
  };

  const onUpgradeSubscriptionClick = () => {
    dispatch(subscriptionSubscribeButtonAction());
  };

  const subscriptionsLoading =
    !subscription ||
    subscriptionLoading ||
    tierListLoading ||
    !subscriptionTiersDDL ||
    subscriptionTiersDDLLoading;

  if (!storage || subscriptionsLoading) {
    return <StorageLoader />;
  }

  return (
    <StorageComponent
      subscription={subscription}
      storage={storage}
      tierList={tierList}
      subscriptionTiersDDL={subscriptionTiersDDL}
      nextTier={nextTier}
      onManageSubscriptionClick={onManageSubscriptionClick}
      onUpgradeSubscriptionClick={onUpgradeSubscriptionClick}
    />
  );
};
